import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "noOfEvents",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field-checkbox" }
const _hoisted_6 = { for: "execution" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, {
    style: _ctx.alertDescriptor.styles.basicCard,
    class: "p-m-2"
  }, {
    content: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InputNumber, {
              id: "noOfEvents",
              inputClass: "kn-material-input",
              modelValue: _ctx.alert.eventBeforeTriggerAction,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.alert.eventBeforeTriggerAction = $event)),
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.valueChanged('eventBeforeTriggerAction', $event.value)))
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('kpi.alert.noOfEvents')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Checkbox, {
            id: "execution",
            modelValue: _ctx.alert.singleExecution,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.alert.singleExecution = $event)),
            binary: true,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.valueChanged('singleExecution', $event)))
          }, null, 8, ["modelValue"]),
          _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('kpi.alert.execution')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["style"]))
}